import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import Button from '../common/Button';
import { map } from 'lodash';
import { imageBasePath, appBasePath } from '../../constants/staticData';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

export default class ManageUser extends Component {
  constructor(props) {
    super(props);
    this.addUser = this.addUser.bind(this);
    this.deleteUserInfo = this.deleteUserInfo.bind(this);

    this.state = {
      searchMobile: false,
      notificationVisible: false,
      showSidebar: false
    };
  }

  componentWillMount() {
    this.props.actions.manageuserinfo();
  }

  componentWillUnmount() {}

  toggleNotification(isVisible) {
    this.setState({ notificationVisible: isVisible });
  }

  toggleMessage(isVisible) {
    this.setState({ messageVisible: isVisible });
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }
  addUser() {
    this.props.router.push(`${appBasePath}/add-Users`);
  }
  deleteUserInfo(userId) {
    // alert("delete user info ----" +userId);
    this.props.actions.deleteUser(userId);
  }

  render() {
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    const { authReducer, manageuserReducer } = this.props;
    return (
      <div>
        {/*Header*/}
        <Header
          hideOption={() => this.setState({ searchMobile: true })}
          commonReducer={this.props.commonReducer}
          actions={this.props.actions}
          notificationCount={2}
          profileName="Derrick Frank"
          notificationCallBack={this.toggleNotification}
          authReducer={this.props.authReducer}
          noAutoSuggestCall="true"
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={this.props.router}
          isNewUser={
            authData &&
              authData.isBusinessRegistered &&
              authData.isGarageProfileCompleted &&
              authData.isGarageServiceSelected
              ? false
              : true
          }
        />
        <div className="main-wrapper">

          <Sidebar
            showSidebar={this.state.showSidebar}
            router={this.props.router}
            actions={this.props.actions}
            commonReducer={this.props.commonReducer}
            authReducer={this.props.authReducer}
          />
          {/*message*/}
          {/*<Extra message="Your email account has been verified. We are open for service!" />*/}

          <div className="container-fluid main-container">
            <div className="page-sec-header col">
              <div className="overview-heading headrer-left-pod overview-heading-mob row">
                <h5>Manage User</h5>
                {manageuserReducer.userInfo.length > 0 &&
                  <Button
                    btnType="label"
                    btnSize="sm"
                    fontSize={16}
                    label="Add"
                    btnCallBack={() => this.addUser(this)}
                    customClass="btn-add-user"
                  />}
              </div>
              <div className="my-account-body">
                {manageuserReducer.userInfo.length > 0 &&
                  manageuserReducer.displayloader == false &&
                  <div className="div-table">
                    <div className="div-table-row-header hide-table-header">
                      <div className="div-table-col-header-user-img" align="center">*</div>
                      <div className="div-table-col-header-user" align="center">Name</div>
                      <div className="div-table-col-header-user">Email ID</div>
                      <div className="div-table-col-header-user">Mobile Number</div>
                      <div className="div-table-col-header-user div-table-usertype">User Type</div>
                      <div className="div-table-col-header div-table-link">Action</div>
                    </div>
                    {map(manageuserReducer.userInfo, (info, index) => {
                      return (
                        <div className="div-table-row">
                          <div className="hide-table-row">
                            <div className="div-table-col-img">
                              <img src={info.driver.profilePhoto} className="" />
                            </div>
                            <div className="div-table-col-user">{info.driver.name}</div>
                            <div className="div-table-col-user">{info.driver.email}</div>
                            <div className="div-table-col-user">{info.driver.phone}</div>
                            <div className="div-table-col-user div-table-usertype">
                              {info.driver_type.displayname}
                            </div>
                            <div className="div-table-col div-table-link div-table-edit">
                              <a
                                onClick={e => {
                                  this.props.router.push(`${appBasePath}/edit-user-info/${info.driver.id}`);
                                }}
                                className="edit-user res-edit-user-view"
                              >
                                <label className="mdi mdi-border-color" />
                                <span>Edit</span>
                              </a>
                              <a
                                onClick={() => {
                                  this.deleteUserInfo(info.driver.id);
                                }}
                              >
                                <label className="mdi mdi-delete" />
                                <span>Delete</span>
                              </a>
                            </div>
                          </div>
                          <div className=" mobile-row-view">
                            <div className="mobile-box">
                              <div className="mobile-box-wrapper">
                                <div className="mobile-row-box">
                                  <div className="box-field box-field-header">Name</div>
                                  <div className="box-field box-field-txt">{info.driver.name}</div>
                                </div>
                                <div className="mobile-row-box">
                                  <div className="box-field box-field-header">Email</div>
                                  <div className="box-field box-field-email box-field-txt">{info.driver.email}</div>
                                </div>
                                <div className="mobile-row-box">
                                  <div className="box-field box-field-header">Mobile Number</div>
                                  <div className="box-field box-field-txt">{info.driver.phone}</div>
                                </div>
                                <div className="mobile-row-box">
                                  <div className="box-field box-field-header">User Type</div>
                                  <div className="box-field box-field-txt">{info.driver_type.displayname}</div>
                                </div>
                                <div>
                                  <div className="mobile-row-box-edit">
                                    <a
                                      onClick={e => {
                                        this.props.router.push(`${appBasePath}/edit-user-info/${info.driver.id}`);
                                      }}
                                      className=""
                                    >
                                      <label className="mdi mdi-border-color" />
                                      <span>Edit</span>
                                    </a>
                                  </div>
                                  <div className="text-right">
                                    <a
                                      onClick={() => {
                                        this.deleteUserInfo(info.driver.id);
                                      }}
                                    >
                                      <label className="mdi mdi-delete" />
                                      <span>Delete</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div className="" />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>}{manageuserReducer.userInfo.length == 0 &&
                  manageuserReducer.displayloader == false &&
                  <div className="empty-list-display">
                    <img src={`${imageBasePath}/manage_users.png`} alt="No User Details" />
                    <h5>Oops! Looks like you haven't added any User's yet.</h5>
                    <Button
                      btnType="label"
                      btnSize="sm"
                      fontSize={16}
                      label="Add"
                      btnCallBack={() => this.addUser(this)}
                      customClass="btn-add-user"
                    />
                  </div>}
                {manageuserReducer.displayloader == true &&
                  <div className="page-loader">
                    <div className="loader-image">
                      <img src={`${imageBasePath}/loader.gif`} />
                    </div>
                  </div>}

              </div>
            </div>
          </div>
        </div>
        {this.state.searchMobile &&
          <div>

            <MobileHeaderSearch
              mobile={true}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              mobSearchClick={() => this.setState({ searchMobile: false })}
            />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ManageUser/manageUser.jsx